import { $tracing } from '../tracing';

export const bindAppFail = ({ risk_token, telegramUserInfo, error }: any) => {
  $tracing.addEvent({
    t: 'bind third app fail',
    ext: {
      risk_token,
      telegramUserInfo,
      error,
    },
  });
};

export const unbindAppFail = ({ risk_token, error }: any) => {
  $tracing.addEvent({
    t: 'unbind third app fail',
    ext: {
      risk_token,
      error,
    },
  });
};
